import { useGoogleLogin } from '@react-oauth/google';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import React, { PropsWithChildren } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Navigate } from 'react-router-dom';
import { LoadingSpinner } from 'design-system/src/components/LoadingSpinner/LoadingSpinner';
import { url } from './api';
import { AuthContext } from './authContext';

export { AuthContext };

export const LoginProvider = (props: PropsWithChildren) => {
  const { isLoading, isError, data } = useQuery({
    queryKey: ['user'],
    queryFn: () =>
      axios
        .get(url('/info'), {
          withCredentials: true,
        })
        .then((res) => res.data),
    retry: false,
  });

  if (isLoading) {
    return <LoadingSpinner />;
  }

  let value;

  if (isError) {
    value = { auth: false, user: null };
  } else {
    value = { auth: true, user: data };
  }

  return <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>;
};

export const LoginRequred = (props: PropsWithChildren) => {
  const authContext = React.useContext(AuthContext);

  if (authContext.auth === false) {
    return <Navigate to="/" />;
  }

  return <>{props.children}</>;
};

export const GoogleLogin = () => {
  const queryClient = useQueryClient();
  const login = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: async (codeResponse) => {
      await axios.post(
        url('/auth'),
        {
          code: codeResponse.code,
        },
        {
          withCredentials: true,
        },
      );
      await queryClient.refetchQueries({ queryKey: ['user'], type: 'active', exact: true });
    },
    // eslint-disable-next-line no-console
    onError: (errorResponse) => console.log(errorResponse),
  });
  return (
    <a href="#" onClick={login}>
      Login with Google
    </a>
  );
};

export const MicrosoftLogin = () => {
  const queryClient = useQueryClient();
  const { instance } = useMsal();

  const handleMicrosoftLogin = async () => {
    try {
      const loginRequest = {
        scopes: ['https://graph.microsoft.com/User.Read'],
      };

      const response = await instance.loginPopup(loginRequest);

      await axios.post(
        url('/auth/microsoft'),
        {
          accessToken: response.accessToken,
        },
        {
          withCredentials: true,
        },
      );
      await queryClient.refetchQueries({ queryKey: ['user'], type: 'active', exact: true });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  return (
    <a href="#" onClick={handleMicrosoftLogin}>
      Login with Microsoft
    </a>
  );
};

export const Login = () => {
  return (
    <div style={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
      <GoogleLogin />
      <MicrosoftLogin />
    </div>
  );
};
